import React from 'react';
import ModalOverlay from '../../shared/ModalOverlay';
import { DistroList } from '../../types';

interface DistroListModalProps {
  active: boolean;
  onClose: () => void;
  distros: DistroList[];
  onCreate: () => void;
  onView: (id: number) => void;
  onEdit: (id: number) => void;
  onSchedule: (id: number) => void;
  onDelete: (id: number) => void;
}

const DistroListModal: React.FC<DistroListModalProps> = ({
  active, onClose, distros, onCreate, onView, onEdit, onSchedule, onDelete,
}) => {
  return (
    <ModalOverlay active={active} onClose={onClose}>
      <div className="modal modal-narrow">
        <div className="modal-header">
          <h2>Distribution Lists</h2>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <button className="btn btn-primary btn-sm" onClick={onCreate} title="Create new list">+</button>
            <button className="modal-close" onClick={onClose}>&times;</button>
          </div>
        </div>
        <div style={{ padding: '1rem 1.5rem', minHeight: '80px' }}>
          {!distros.length ? (
            <p style={{ color: 'var(--text-dim)', textAlign: 'center' }}>No distribution lists yet.</p>
          ) : (
            distros.map((d) => (
              <div key={d.id} className="distro-item">
                <span className="distro-item-name">{d.name}</span>
                <div className="distro-item-actions">
                  <button className="btn-icon view" title="View emails" onClick={() => onView(d.id)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" />
                    </svg>
                  </button>
                  <button className="btn-icon edit" title="Edit list" onClick={() => onEdit(d.id)}>&#9998;</button>
                  {/* Scheduled distro emails are not enabled at this time. The
                      schedule button is hidden but the underlying modal, handlers,
                      API, and Lambda remain intact for future re-enablement — flip
                      this guard back to true to restore. */}
                  {false && (
                    <button className="btn-icon" title="Create/Edit Schedule" onClick={() => onSchedule(d.id)}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" />
                      </svg>
                    </button>
                  )}
                  <button className="btn-icon delete" title="Delete list" onClick={() => onDelete(d.id)}>&times;</button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </ModalOverlay>
  );
};

export default DistroListModal;
